module.exports = __webpack_public_path__ + "static/img/one.7449a3ed.png";